import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import axios from "axios";

export default {
  name: "LeaveDetail",
  components: {
    MainLayout,
    Loading,
  },

  data() {
    return {
      CONFIG,
      noDataMsg: CONFIG.NO_DATA_EXIST,
      isLoading: false,
      leaveData: {},
    };
  },

  methods: {
    formatTime(time) {
      if (!time) return "";
      return time.slice(0, 5);
    },

    getLeaveDetail() {
      axios.get(`${this.leaveApiBase}/detail/${this.$route.params.id}`)
        .then((response) => {
          this.leaveData = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          if (error.response && error.response.status == 403) {
            this.$router.push({ name: 'teacherLeaveList' });
          }
          this.isLoading = false;
        });
    },
  },

  computed: {
    isHrOperator() {
      const role = Number(this.$store.state.user?.role);
      return role === CONFIG.ROLE.ID.HR_OPERATOR || role === CONFIG.ROLE.ID.SUPER_ADMIN;
    },
    leaveApiBase() {
      return this.isHrOperator ? 'hr/employee-leave' : 'employee-leave';
    }
  },

  mounted() {
    this.isLoading = true;
    this.getLeaveDetail();
  },
};
